import React, { useEffect, useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input, Table, TableHeader, TableColumn, TableBody, TableRow, TableCell} from "@nextui-org/react";
import { MdOutlineDelete } from "react-icons/md";
import axios from "axios";
import { products_uri } from "../../../../utils/url";
import { toast } from "react-toastify";
import { LEASING_TYPES, TYPES } from "../../../../utils/types";

export default function UserProductDetail({depo, name}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([]);
  
  
  const Get = async() =>{
    setLoad(true);
    try{
      const res = await axios.get(products_uri+`/detail/user?phone=${name}&depo?${depo}`);
      setData(res.data);
      setLoad(false);
    }catch(err){
      setLoad(false);
      console.log(err);
    }
  }

  function open (){
    onOpen();
    Get();
  }

  function sss (s){
    const a = data.filter(it => it.type === s);
    return a.length;
  }

  return (
    <>
      <h1 onClick={open} className='text-sm font-bold cursor-pointer'>{name}</h1>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="5xl">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex justify-between gap-1 font-Roboto">
                <h1>Барааны дэлгэрэнгүй</h1>
              </ModalHeader>
              <ModalBody>
                <div className="font-Roboto ">
                <Table aria-label="Example static collection table">
                  <TableHeader>
                    <TableColumn>Утасны дугаар</TableColumn>
                    <TableColumn>Захиалгын тоо</TableColumn>
                    <TableColumn>Нийт</TableColumn>
                    <TableColumn>Карго</TableColumn>
                    <TableColumn>Хүлээлгэж өгсөн огноо</TableColumn>
                    <TableColumn>Төлөв</TableColumn>
                  </TableHeader>
                  <TableBody>
                    {
                      data.map((it, index) => {
                        return(
                          <TableRow key={index}>
                            <TableCell>{it.phone_or_depo}</TableCell>
                            <TableCell>{it.too}</TableCell>
                            <TableCell>{Number(it.too)*Number(it.pay)}</TableCell>
                            <TableCell>{it.pay}</TableCell>
                            <TableCell>{it.date}</TableCell>
                            <TableCell>
                              <h1 className='flex items-center gap-3'>
                                {it.type === TYPES.REQUESTED && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Хүлээгдэж байгаа</h1>
                                    </div>
                                )}
                                {it.type === TYPES.IRSEN && (it.delivery === TYPES.REQUESTED) && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Хүргэлтэнд бүртгүүлсэн</h1>
                                    </div>
                                )}
                                {it.type === TYPES.IRSEN && (!it.delivery || it.delivery === null) && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Ирсэн</h1>
                                    </div>
                                )}
                                {it.type === TYPES.REJECTED && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>{it.leasing === LEASING_TYPES.R ? 'Лизинг цуцлагдсан' : 'Буцаалт хийсэн'}</h1>
                                    </div>
                                )}
                                {it.type === TYPES.CONFIRM && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'> Хүлээлгэж өгсөн {it.delivery === TYPES.CONFIRM && " (хүргэлтээр)"}</h1>
                                    </div>
                                )}
                              </h1>
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
                </div>
              </ModalBody>
              <ModalFooter>
                <div className="flex items-center gap-2">
                  <h1 className="bg-gray-200 rounded-md p-1">Нийт: {data.length}</h1>
                  <h1 className="bg-gray-200 rounded-md p-1">Хүлээгдэж байгаа: {sss(TYPES.REQUESTED)}</h1>
                  <h1 className="bg-gray-200 rounded-md p-1">Ирсэн: {sss(TYPES.IRSEN)}</h1>
                  <h1 className="bg-gray-200 rounded-md p-1">Буцаалт хийсэн: {sss(TYPES.REJECTED)}</h1>
                  <h1 className="bg-gray-200 rounded-md p-1">Хүлээлгэж өгсөн: {sss(TYPES.CONFIRM)}</h1>
                </div>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}